import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function WhatIsSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:grid-cols-2 md:px-6 md:py-20">
        <div>
          <span className="inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            {t("categories.badge")}
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("whatis.title")}
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("whatis.p1")}
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("whatis.p2")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
          >
            {t("whatis.cta")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {[
            "cat.shoes",
            "cat.hoodies",
            "cat.jersey",
            "cat.bags",
          ].map((key) => (
            <div
              key={key}
              className="flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5 text-center"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className="ri-checkbox-circle-line text-xl"></i>
              </span>
              <span className="text-sm font-semibold text-foreground-800">{t(key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}